import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import type { CenterListItem } from "../../../../api/academyEnrolments/enrolmentsService";

interface CenterSectionProps {
  centerList: CenterListItem[];
  selectedCenter: CenterListItem | null;
  loadingCenters: boolean;
  onCenterSelect: (c: CenterListItem) => void;
  disabled?: boolean;
}

const CenterSection: React.FC<CenterSectionProps> = ({
  centerList,
  selectedCenter,
  loadingCenters,
  onCenterSelect,
  disabled,
}) => {
  const centerOptions = centerList.map((c) => ({
    value: c._id,
    label: c.basicDetails.location,
    sublabel: c.basicDetails.address,
    center: c,
  }));

  return (
    <div className="enrolment-form-section">
      <h6 className="enrolment-section-title">
        <span className="enrolment-section-number">5</span>
        Coaching Center
      </h6>

      <Row className="g-3">
        <Col xs={12} md={7}>
          <Form.Label className="mb-1 text-muted" style={{ fontSize: 12 }}>
            Center (Location) *
          </Form.Label>
          {disabled ? (
            <div className="enrolment-readonly-field-wrapper">
              <Form.Control
                readOnly
                value={selectedCenter?.basicDetails.location ?? "—"}
                style={{ pointerEvents: "none" }}
              />
            </div>
          ) : (
            <Select
              classNamePrefix="react-select"
              options={centerOptions}
              isLoading={loadingCenters}
              isDisabled={disabled}
              value={
                selectedCenter
                  ? {
                      value: selectedCenter._id,
                      label: selectedCenter.basicDetails.location,
                      sublabel: selectedCenter.basicDetails.address,
                      center: selectedCenter,
                    }
                  : null
              }
              onChange={(opt) => opt && onCenterSelect(opt.center)}
              placeholder="Select center..."
              formatOptionLabel={(opt) => (
                <div>
                  <div style={{ fontWeight: 500 }}>{opt.label}</div>
                  {opt.sublabel && (
                    <div style={{ fontSize: 11, color: "#888" }}>{opt.sublabel}</div>
                  )}
                </div>
              )}
            />
          )}
        </Col>
      </Row>

      {selectedCenter && (
        <div className="mt-2 text-muted" style={{ fontSize: 12 }}>
          <i className="ri-map-pin-line me-1" />
          {selectedCenter.basicDetails.address}
        </div>
      )}
    </div>
  );
};

export default CenterSection;
